import ErrorPage from "@/pages/_error";
import { defineMessage, FormattedMessage, useIntl } from "react-intl";
import UserOrganizations from "@/components/UserOrganizations";
import Button from "@/components/Button";
import { graphql, Environment } from "react-relay";
import { LoaderArgs } from "@/utils/route";
import { UserOrganizationsPageQuery as UserOrganizationsPageQueryType } from "./__generated__/UserOrganizationsPageQuery.graphql";
import { preload, usePreloaded } from "@/utils/relay";
export default function UserOrganizationsPage() {
  const intl = useIntl();
  const { variables, query } = useUserOrganizationsPageQuery();
  if (!query.entityByUsername) {
    return (
      <ErrorPage
        status={404}
        message={intl.formatMessage(
          { defaultMessage: "@{username} not found" },
          { username: variables.username },
        )}
      />
    );
  }
  const user = query.entityByUsername;
  return (
    <div>
      {query.viewer?.canCreateOrganization && (
        <div className="flex flex-row justify-end pb-8">
          <Button to="/organization/new">
            <FormattedMessage defaultMessage="Create Organization" />
          </Button>
        </div>
      )}
      <UserOrganizations user={user} />
    </div>
  );
}
const UserOrganizationsPageQuery = graphql`
  query UserOrganizationsPageQuery($username: String!) {
    viewer @ifAllowed {
      canCreateOrganization: can(action: CREATE_ORGANIZATION)
    }
    entityByUsername(username: $username) {
      ... on User {
        ...UserOrganizationsFragment
      }
    }
  }
`;
export const loader = (environment: Environment) => {
  return ({ params: { username } }: LoaderArgs) => {
    if (!username) {
      throw new Response("No username", { status: 500 });
    }
    return preload<UserOrganizationsPageQueryType>(
      environment,
      UserOrganizationsPageQuery,
      {
        username,
      },
    );
  };
};
const useUserOrganizationsPageQuery = () =>
  usePreloaded<UserOrganizationsPageQueryType>();

export const lazyHandle = {
  titleI18n: defineMessage({ defaultMessage: "Organizations" }),
};
